import { addImposterToUrl } from 'Utils';
import { api } from './axios';

const baseUrl = '/Medication';

export enum MEDICATION_STATUSES {
  regular = 1,
  cancelled,
  forbidden,
  notAvailable,
}

export enum MEDICATION_OPTIONS_NOT_IN_STOCK {
  SEND_BY_POST = 1,
  GET_BY_MYSELF = 2,
  GET_REPLACEMENT = 3,
  REMOVE_FROM_ORDER = 4,
}

export enum MEDICINE_STATUSES {
  WAITING_TO_OPEN_IN_SYSTEM = 1,
  OPEN_IN_SYSTEM = 2,
  WING_HANDLING = 3,
  MANUAL_PRESCRIPTION_THAT_APPROVED_AND_ISSUED = 4,
  SUPERPHARM_HANDLING = 5,
  SUPERPHARM_FULL_SUPPLY = 6,
  SUPERPHARM_PARTIAL_SUPPLY = 7,
  REJECTED = 8,
  SUPERPHARM_SUPPLY_STOPPED = 9,
}

export interface IPrescriptionsMedication {
  //the number of the medication in the prescription's MedicationCount prop
  medcounter: number;
  medicatioN_CODE: number;
  medicatioN_NAME: string;
  dosage?: number;
  doseperday?: number;
  //severalDays
  fornumberdays?: number;
  totaL_QUANTITY?: number;
  medremark?: string;
  countDelivery?: number;
  medstatus?: number;
  supplyind?: number;
  narcoticind?: boolean;
}

export interface IMedication {
  //the number of the medication in the prescription's MedicationCount prop
  medcounter?: number;
  medicatioN_CODE?: number;
  medicatioN_NAME: string;
  //expirationDate
  nextrefreshdate: Date;
  dosage?: number;
  doseperday?: number;
  //severalDays
  fornumberdays?: number;
  totaL_QUANTITY?: number;
  remark?: string;
  narcoticind?: boolean;
  //specify if disposable or not
  onceind?: number;
  medstatus?: MEDICATION_STATUSES;
  lackMedicineNote?: string;
  OutOfStockOptionCode?: number;
}

export interface IOnceIndOptions {
  code: number;
  text: string;
}

export enum PrescIdentifierType {
  OriginalOrderId = 1,
  PrescShemeshCode = 2,
}

export const getMedications = async () => {
  const medicationDto = await api.get<IMedication[]>(
    addImposterToUrl(baseUrl, true)
  );
  if (medicationDto.data) {
    return medicationDto.data;
  }
};

export const getMedicationByID = async (
  id: string | undefined,
  type: number
) => {
  const medicationDto = await api.get<IMedication>(
    addImposterToUrl(`Prescription/${id}?identifierType=${type}`, false)
  );
  if (medicationDto.data) {
    return medicationDto.data;
  }
};

export const getOutOfStockOptions = async () => {
  const medGeneralContent = await api.get('MedGeneralContent');
  if (medGeneralContent.data) {
    return medGeneralContent.data.outOfStockOptions;
  }
};

export const getOnceIndOptions = async () => {
  const medGeneralContent = await api.get('MedGeneralContent');
  if (medGeneralContent.data) {
    return medGeneralContent.data.onceIndOptionds;
  }
};
